<app-navbar></app-navbar>

<section class="min-h-[60dvh] bg-black text-black">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-2 pt-20 md:pt-24 pb-10">
        <div class="text-white p-1 rounded-lg">
            <img [src]="currentImage" class="w-full" alt="" srcset="">
            <div class="flex justify-center items-center mt-2">

                <button class="cursor-pointer me-2 inline-flex items-center justify-center h-24 px-1 gap-2 text-sm font-medium tracking-wide transition duration-300 border rounded focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none">
                    <img src="src/assets/img/xnex_page/684fff0c50e2adb9bd0f9f51_Xnex-30-ombra-p-2600.webp" (click)="imageSource('src/assets/img/xnex_page/684fff0c50e2adb9bd0f9f51_Xnex-30-ombra-p-2600.webp')" class="w-20 h-20" alt="" srcset="">
                </button>

                <button class="cursor-pointer me-2 inline-flex items-center justify-center h-24 px-1 gap-2 text-sm font-medium tracking-wide transition duration-300 border rounded focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none">
                    <img src="src/assets/img/xnex_page/659e716c397d46384399dc27_xnex-frontal-p-2600.webp" (click)="imageSource('src/assets/img/xnex_page/659e716c397d46384399dc27_xnex-frontal-p-2600.webp')" class="w-20 h-20" alt="" srcset="">
                </button>

                <button class="cursor-pointer me-2 inline-flex items-center justify-center h-24 px-1 gap-2 text-sm font-medium tracking-wide transition duration-300 border rounded focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none">
                    <img src="src/assets/img/xnex_page/659e71641ccc97ccc4f89bd0_xnex-pattern.webp" (click)="imageSource('src/assets/img/xnex_page/659e71641ccc97ccc4f89bd0_xnex-pattern.webp')" class="w-20 h-20" alt="" srcset="">
                </button>
                


            </div>
        </div>
        <div class="bg-black text-white p-4 rounded-lg animate-fade-up animate-ease-in">
            <div class="mt-8 md:mt-24 mb-4 ">
                <p class="text-md uppercase ">{{texts.hero.subtitle}}</p>
                <h1 class="text-3xl font-bold text-green-400 my-2">
                    <span>
                        <img src="src/assets/img/xnex_page/left.png" class="inline-block w-8 h-8 align-middle" alt="XNEX Logo">
                    </span>
                    <span>
                        {{texts.hero.title}}
                    </span>
                    <span>
                        <img src="src/assets/img/xnex_page/right.webp" class="inline-block w-8 h-8 align-middle" alt="XNEX Logo">
                    </span>
                </h1>
                <p class="text-lg uppercase md:w-2/3">
                    {{texts.hero.description}}
                </p>

            </div>
            <div>
                <div class="grid grid-cols-4 gap-2 mt-4 text-center md:w-1/2">
                    <div class="mx-auto items-center justify-center">
                        <img src="src/assets/img/xnex_page/6579d0e0ae0eb3b566205777_Passenger.svg" alt="inktech" class="w-8 rounded mx-auto mb-2" />
                        <p class="text-xs">
                            {{texts.general_titles.categories[0]}}
                        </p>
                    </div>
                    <div class="mx-auto items-center justify-center">
                        <img src="src/assets/img/xnex_page/6579d143429115628804a525_Electric.svg" alt="healteck" class="w-8 rounded mx-auto mb-2" />
                        <p class="text-xs">
                            {{texts.general_titles.categories[1]}}
                        </p>
                    </div>
                    <div class="mx-auto items-center justify-center ps-6 border-l-2 border-green-500">
                        <img src="src/assets/img/xnex_page/6579d11e36763f432821e5f2_Summer.svg" alt="verano" class="w-8 rounded mx-auto mb-2" />
                        <p class="text-xs">
                            {{texts.general_titles.categories[2]}}
                        </p>
                    </div>
                    
                </div>
            </div>
            <div id="caracteriticas" class="mt-8">
                <h2 class="text-xl uppercase">
                    {{texts.general_titles.characteristics_title}}
                </h2>
                <div class="grid grid-cols-4 gap-2 mt-4 text-center md:w-1/2">
                    <div class="mx-auto items-center justify-center">
                        <img src="/assets/img/electric_car_type/Inktech.svg" alt="inktech" class="w-8 rounded mx-auto mb-2" />
                        <p class="text-xs">Inktech</p>
                    </div>
                    <div class="mx-auto items-center justify-center">
                        <img src="/assets/img/electric_car_type/Healteck.svg" alt="healteck" class="w-8 rounded mx-auto mb-2" />
                        <p class="text-xs">Healteck</p>
                    </div>
                    <div class="mx-auto items-center justify-center">
                        <img src="/assets/img/electric_car_type/Silenteck.svg" alt="silenteck" class="w-8 rounded mx-auto mb-2" />
                        <p class="text-xs">Silenteck</p>
                    </div>
                    <div class="mx-auto items-center justify-center">
                        <img src="/assets/img/electric_car_type/XL.svg" alt="XL" class="w-8 rounded mx-auto mb-2" />
                        <p class="text-xs">XL</p>
                    </div>
                </div>
                <div class="my-4">
                    <button class="cursor-pointer uppercase inline-flex items-center justify-center h-10 gap-2 px-5 text-sm font-medium tracking-wide transition duration-300 
                    border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600 
                    focus:border-green-700 focus:text-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none">
                        <a href="https://mundoev.com/resultados?utm_source=prinxcr&utm_medium=referral&utm_campaign=llantas" target="_blank" rel="noopener noreferrer" class="flex items-center justify-center h-full w-full gap-2">
                            <span>
                                {{texts.general_titles.buy_btn}}
                            </span>
                            <span><img src="src/assets/img/xnex_page/right.webp" class="inline-block w-4 h-4 align-text-bottom" alt="XNEX Logo"></span>
                        </a>
                    </button>
                </div>

            </div>
        </div>
        
        
    </div>
    <div class="w-full">
        <!-- Component: Image overlay card -->
        <div class="overflow-hidden bg-white text-slate-500">
        <!-- Image -->
            <figure class="relative">
                <img src="src/assets/img/xnex_page/6835dcbe989f31740e0421cd_xnex banner.png" alt="card image" class="w-full" />
                <figcaption class="absolute -bottom-1 left-0 w-full p-2 pt-8 text-white bg-gradient-to-t from-black">
                    <div class="text-center">
                        <h3 class="text-lg md:text-2xl font-medium uppercase">
                            {{texts.second_section.title}}
                        </h3>
                    </div>
                </figcaption>
            </figure>
        </div>
        <!-- End Image overlay card -->
    </div>
    <div class="max-w-3xl text-center mx-4 md:mx-auto mt-10 text-white pb-8">
        <p class="text-lg">
            {{texts.second_section.description}}
        </p>
    </div>

    

</section>

<section class="bg-white text-black py-6">
    <div class="max-w-4xl text-center mx-4 md:mx-auto mt-10 bg-white">

        <div>
            <h2 class="font-bold text-3xl uppercase">
                {{texts.third_section.title}}
            </h2>
            <p class="text-base">
                {{texts.second_section.description}}
            </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
            <div class="rounded-lg p-6 text-black">
                <img src="src/assets/img/xnex_page/658055c4daad91ab69c6e240_Inktech 2.png.webp" alt="" srcset="" class="rounded-lg">
            </div>
            <div class="rounded-lg p-6 md:pt-20 text-black text-left">
                <h3 class="text-xl font-semibold mb-2 uppercase">Inktech™</h3>
                <p>
                    {{texts.third_section.details[0]}}
                </p>
            </div>

            <div class="rounded-lg p-6 md:pt-36 text-black text-left">
                <h3 class="text-xl font-semibold mb-2 uppercase">silenteck™</h3>
                <p>
                    {{texts.third_section.details[1]}}
                </p>
            </div>
            <div class="rounded-lg p-6 text-black">
                <img src="src/assets/img/xnex_page/658055c2ecbcd4d81b3267fd_SILENTECK 2.png.webp" alt="" srcset="" class="rounded-lg">
            </div>
            

            <div class="rounded-lg p-6 text-black">
                <img src="src/assets/img/xnex_page/658055c1568e15673abb6bb7_Healteck 2.png.webp" alt="" srcset="" class="rounded-lg">
            </div>
            <div class="rounded-lg p-6 md:pt-36 text-black text-left">
                <h3 class="text-xl font-semibold mb-2 uppercase">healteck™</h3>
                <p>
                    {{texts.third_section.details[2]}}
                </p>
            </div>
        </div>
    </div>
</section>
<section class="bg-black text-white py-6">
    <div class="max-w-4xl text-center mx-4 md:mx-auto mt-10 bg-black">
        <h2 class="font-bold text-3xl text-green-400">
            {{texts.fourth_section.title}}
        </h2>
        <p class="text-lg">
            {{texts.fourth_section.description}}
        </p>
        <img src="src/assets/img/xnex_page/656491876960eed4e78a0a2f_xnex-shoulder.webp"  class="w-full" alt="" srcset="">
        <div class="mt-6">
            <button class="cursor-pointer uppercase inline-flex items-center justify-center h-10 gap-2 px-5 text-sm font-medium tracking-wide transition duration-300 
            border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600 
            focus:border-green-700 focus:text-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none">
                <a href="https://mundoev.com/resultados?utm_source=prinxcr&utm_medium=referral&utm_campaign=llantas" target="_blank" rel="noopener noreferrer" class="flex items-center justify-center h-full w-full gap-2">
                    <span>
                        {{texts.general_titles.buy_btn}}
                    </span>
                    <span><img src="src/assets/img/xnex_page/right.webp" class="inline-block w-4 h-4 align-text-bottom" alt="XNEX Logo"></span>
                </a>
            </button>
        </div>
    </div>

</section>

<app-footer></app-footer>